import React from 'react';
import { apiBase } from '../../utils/config';
import UserImage from '../../assets/images/Logo.svg';
import moment from 'moment';

const ResultPreviewPDF = React.forwardRef((props, ref) => {
    const { templateConfiguration, pdfData } = props;
    
    const activityData = pdfData?.GradeDetails?.filter(item => item.Type === 'Activity') || [];
    const elementsData = pdfData?.GradeDetails?.filter(item => item.Type === 'Elements') || [];
    const termElementsKeys = elementsData.length > 0
        ? Object.keys(elementsData[0]).filter(key => !['name', 'type'].includes(key.toLowerCase()))
        : [];

    const termActivityKeys = activityData.length > 0
        ? Object.keys(activityData[0]).filter(key => !['name', 'type'].includes(key.toLowerCase()))
        : [];

    return <div className='reault-main'>
        <div className='student-result'>
            <header>
                <div style={{ width: '100%' }}>
                    <img
                        src={templateConfiguration?.SchoolLogo ? `${apiBase}/Documents/${templateConfiguration?.SchoolLogo}` : UserImage}
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = UserImage;
                        }}
                    />
                </div>
            </header>
            <section class="report-info">
                <div className='report-box'>
                    <p className='report-text'>report card</p>
                </div>
                <div className='class-box'>
                    <p className='class-text'>class : <span>{templateConfiguration?.BodySection?.filter(x => x?.key === 'Class').length > 0 && pdfData?.Class} - {templateConfiguration?.BodySection?.filter(x => x?.key === 'Section').length > 0 && pdfData?.Section || ''}</span></p>
                </div>
                {templateConfiguration?.BodySection?.filter(x => x?.key === 'AcademicYear').length && <div className='class-box'>
                    <p className='ay-text'>academic year : <span>{pdfData?.AcademicYear ?? '-'}</span></p>
                </div>}
                <div className='student-details'>
                    <div className='student-texts'>
                        <div className='text-box-par'>
                            {templateConfiguration?.BodySection?.filter(x => x?.key === 'FullName').length &&
                                <p>student's name :</p>}
                            {templateConfiguration?.BodySection?.filter(x => x?.key === 'FName').length &&
                                <p>father's name :</p>}
                            {templateConfiguration?.BodySection?.filter(x => x?.key === 'DOB').length && <p>date of birth :</p>}
                            {templateConfiguration?.BodySection?.filter(x => x?.key === 'Address').length && <p>address :</p>}
                        </div>
                        <div className='text-box-cha'>
                            {templateConfiguration?.BodySection?.filter(x => x?.key === 'FullName').length && <p> {pdfData?.Name ?? '-'}</p>}
                            {templateConfiguration?.BodySection?.filter(x => x?.key === 'FName').length && <p>{pdfData?.FName || '-'}</p>}
                            {templateConfiguration?.BodySection?.filter(x => x?.key === 'DOB').length && <p>{moment(pdfData?.DOB).format("DD-MM-YYYY")}</p>}
                            {templateConfiguration?.BodySection?.filter(x => x?.key === 'Address').length && <p>{pdfData?.Address || '-'}</p>}
                        </div>
                    </div>
                    <div className='student-numbers'>
                        <div className='text-par'>
                            {templateConfiguration?.BodySection?.filter(x => x?.key === 'RollNo').length && <p className=''>roll no</p>}
                            {templateConfiguration?.BodySection?.filter(x => x?.key === 'GRNo').length && <p className=''>g. r. no.</p>}
                        </div>
                        <div className='text-cha'>
                            {templateConfiguration?.BodySection?.filter(x => x?.key === 'RollNo').length && <p>{pdfData?.RollNo ?? '-'}</p>}
                            {templateConfiguration?.BodySection?.filter(x => x?.key === 'GRNo').length && <p>{pdfData?.GRNo ?? '-'}</p>}
                        </div>
                    </div>
                </div>
            </section>
            <section class="result-table footer-table">
                <table>
                    <thead>
                        <tr>
                            <th className='yello'>Scholastic Area</th>
                            {pdfData?.TermData.map((term, index) => (
                                <>
                                    <th key={index} className={index % 2 === 0 ? 'light-peach' : 'light-bluish'} colSpan="5">
                                        {`${term.TermName} (${term?.Marks} Marks)`}
                                    </th>
                                </>
                            ))}
                            <th colspan="2" className='p-p-0 light-yello'>Overall
                                <tr>
                                    <th className='t1-t2 light-yello'>T1 + T2</th>
                                </tr>
                            </th>
                        </tr>
                        <tr>
                            <th className='yello'>Subject</th>
                            {pdfData?.TermData.map((term, index) => (
                                Object.keys(pdfData?.MarksData?.[0]?.[term.TermName] || {}).map(testType => (
                                    <th className={index % 4 === 0 ? 'light-peach' : 'light-bluish'}>{testType}</th>
                                ))
                            ))}
                            <th className='light-yello'>
                                Grand Total ({pdfData?.MarksData?.[0]?.GrandTotalType || 0})
                            </th>
                            <th className='light-yello'>Grade</th>
                        </tr>
                    </thead>
                    <tbody>
                        {pdfData?.MarksData.map(subject => (
                            <tr key={subject?.Subject}>
                                <td>{subject?.Subject}</td>
                                {pdfData?.TermData.map(term => (
                                    Object.keys(subject?.[term.TermName] || {}).map(testType => (
                                        <td className='purple'>{subject?.[term.TermName]?.[testType] == 0 ? '-' : subject?.[term.TermName]?.[testType] ?? '-'}</td>
                                    ))
                                ))}
                                <td>{subject?.GrandTotal == 0 ? '-' : subject?.GrandTotal ?? '-'}</td>
                                <td>{subject?.Grade ?? '-'}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                <div className="footer-row">
                    <div className="column-one">
                        <p className="title">{pdfData?.GradeData?.GradeTemplateName ?? '-'}</p>
                    </div>
                    <div className="grades-container">
                        {pdfData?.GradeData?.GradeTemplateValues?.map((grade) => (
                            <div
                                key={grade._id}
                                className="grade-box"
                                style={{ backgroundColor: `#${grade.HexCode}` }}
                            >
                                <p>
                                    {grade?.GradeName} ({grade?.PercentageFrom} - {grade?.PercentageTo})
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <div className='co-main-box'>
                {activityData.length > 0 && <div className='co-left'>
                    <div className='grad-points'>
                        <p>co scholastic ares</p>
                        <p>(3 point grading scale a,b,c)</p>
                    </div>
                    <div className="co-acti">
                        <div className="text-par">
                            <p className="p-text-center">activities</p>
                            {activityData?.map((item, idx) => (
                                <p className="text" key={idx}>{item?.Name}</p>
                            ))}
                        </div>

                        {termActivityKeys.map((termKey, termIdx) => (
                            <div className="text-cha" key={termIdx}>
                                <p>{termKey?.toLowerCase().replace("term", "t ")}</p>
                                {activityData.map((item, i) => (
                                    <p className="text" key={i}>{item[termKey] || '-'}</p>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>}
                {elementsData.length > 0 && <div className='co-left'>
                    <div className='grad-points'>
                        <p>co scholastic ares</p>
                        <p>(3 point grading scale a,b,c)</p>
                    </div>
                    <div className="co-acti">
                        <div className="text-par">
                            <p className="p-text-center">elements</p>
                            {elementsData.map((item, idx) => (
                                <p className="text" key={idx}>{item.Name}</p>
                            ))}
                        </div>

                        {termElementsKeys.map((termKey, termIdx) => (
                            <div className="text-cha" key={termIdx}>
                                <p>{termKey.toLowerCase().replace("term", "t ")}</p>
                                {elementsData.map((item, i) => (
                                    <p className="text" key={i}>{item[termKey] || '-'}</p>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>}
            </div>
            <div className='overall-main'>
                <p className='overall-text'>overall</p>
                <div className='overall-cha'>
                    {templateConfiguration?.FooterSection?.filter(x => x?.key === 'Marks').length &&
                        <div className='overall-numbers border-left'>
                            <div className='text-par'>
                                <p className=''>marks</p>
                            </div>
                            <div className='text-cha'>
                                <p className=''>{pdfData?.TotalMarks ?? 0}</p>
                            </div>
                        </div>}
                    {templateConfiguration?.FooterSection?.filter(x => x?.key === 'Percentage').length &&
                        <div className='overall-numbers'>
                            <div className='text-par'>
                                <p className=''>percentage</p>
                            </div>
                            <div className='text-cha'>
                                <p className=''>{pdfData?.Percentage}</p>
                            </div>
                        </div>}
                    {templateConfiguration?.FooterSection?.filter(x => x?.key === 'Grade').length &&
                        <div className='overall-numbers'>
                            <div className='text-par'>
                                <p className=''>grade</p>
                            </div>
                            <div className='text-cha'>
                                <p className=''>{pdfData?.Grade ?? '-'}</p>
                            </div>
                        </div>}
                    {templateConfiguration?.FooterSection?.filter(x => x?.key === 'Rank').length &&
                        <div className='overall-numbers border-right'>
                            <div className='text-par'>
                                <p className=''>rank</p>
                            </div>
                            <div className='text-cha'>
                                <p className=''>{pdfData?.Rank ?? '-'}</p>
                            </div>
                        </div>}
                </div>
                <div className='overall-cha'>
                    {templateConfiguration?.FooterSection?.filter(x => x?.key === 'Attendance').length &&
                        <div className='overall-numbers border-left p-m-0'>
                            <div className='text-par'>
                                <p className=''>attendance</p>
                            </div>
                            <div className='text-cha'>
                                <p className=''>{pdfData?.Attendance ?? '-'}</p>
                            </div>
                        </div>}
                    {/* {templateConfiguration?.FooterSection?.filter(x => x?.key === 'Remark').length && */}
                    <div className='overall-numbers border-right p-m-0'>
                        <div className='text-par'>
                            <p className=''>remarks</p>
                        </div>
                        <div className='text-cha'>
                            <p className=''>{pdfData?.Remarks ?? '-'}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className='sign-main'>
                <div className='sign-cha'>
                    <img
                        src={templateConfiguration?.SealImage ? `${apiBase}/Documents/${templateConfiguration?.SealImage}` : UserImage}
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = UserImage;
                        }}
                        style={{ width: '200px', height: '200px', objectFit: 'contain', marginRight: '10px' }}
                    />
                    <p>{moment().format("DD-MM-YYYY")}</p>
                </div>
                <hr />
                <div className='sign-cha'>
                    <img
                        src={pdfData?.ClassTeacherProfileUrl ? `${apiBase}/UserProfilePic/${pdfData?.ClassTeacherProfileUrl}` : UserImage}
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = UserImage;
                        }}
                        style={{ width: '200px', height: '200px', objectFit: 'contain', marginRight: '10px' }}
                    />
                    <p>class teacher</p>
                </div>
                <hr />
                <div className='sign-cha'>
                    <img
                        src={templateConfiguration?.PrincipalSignImage ? `${apiBase}/Documents/${templateConfiguration?.PrincipalSignImage}` : UserImage}
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = UserImage;
                        }}
                        style={{ width: '200px', height: '200px', objectFit: 'contain', marginRight: '10px' }}
                    />
                    <p>principal</p>
                </div>
            </div>        </div>
        <p className='footer-text'>
            {templateConfiguration?.FooterSection?.filter(x => x?.key === 'SCLAddress').length && pdfData?.SchoolAddress}, {templateConfiguration?.FooterSection?.filter(x => x?.key === 'SCLPhone').length && pdfData?.SchoolPhone},
            {templateConfiguration?.FooterSection?.filter(x => x?.key === 'SCLEmail').length && pdfData?.SchoolEmail}
        </p>
    </div>
});

export default ResultPreviewPDF;
